import type {
    ErrorFn,
    IdentityUserManagerSettings,
    User,
} from '@uipath/auth-core';
import {
    getUserManager,
    IdentityUserManager,
} from '@uipath/auth-core';
import type { PropsWithChildren } from 'react';
import React, {
    useEffect,
    useMemo,
} from 'react';
import { AuthProvider } from 'react-oidc-context';

import { AuthPropsProvider } from './AuthProps';

export type AuthConfiguration = Omit<IdentityUserManagerSettings, 'onSigninError'>;

interface AuthConfigurationProps {
    configuration: AuthConfiguration;
}

interface ErrorHandlerProps {
    onError?: ErrorFn;
}

interface CallbackProps {
    onSigninCallback: (user: User | void) => any;
}

type AuthProviderProps = CallbackProps & AuthConfigurationProps & ErrorHandlerProps;

export const UiPathAuthProvider = ({
    children, configuration, onSigninCallback, onError,
}: PropsWithChildren<AuthProviderProps>) => {

    const userManager = useMemo(() => getUserManager() ?? new IdentityUserManager({
        ...configuration,
        onSigninError: onError,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [ ]);

    useEffect(() => () => {
        userManager.unregisterCustomEvents();
    }, [ userManager ]);

    return (
        <AuthPropsProvider
            userManager={userManager}>
            <AuthProvider
                userManager={userManager}
                onSigninCallback={onSigninCallback}>
                {children}
            </AuthProvider>
        </AuthPropsProvider>
    );
};
